import { jsx as _jsx } from "react/jsx-runtime";
import { useBreakpointsContext } from "@air/provider-media-query";
import { memo, useCallback, useEffect, useRef } from "react";
export const ContentCollectionGalleryAssetButton = /*#__PURE__*/ memo((param)=>{
    let { preSelectItem, confirmItemSelection, isSelectable, onClick } = param;
    const { isAboveMediumScreen } = useBreakpointsContext();
    const isMouseDownRef = useRef(false);
    const onMouseUp = useCallback(()=>{
        isMouseDownRef.current = false;
        if (isAboveMediumScreen && isSelectable) {
            confirmItemSelection();
        }
    }, [
        confirmItemSelection,
        isAboveMediumScreen,
        isSelectable
    ]);
    useEffect(()=>{
        if (isMouseDownRef.current) {
            window.addEventListener("mouseup", onMouseUp, {
                once: true
            });
        }
        return ()=>{
            window.removeEventListener("mouseup", onMouseUp);
        };
    }, [
        onMouseUp
    ]);
    const onMouseDown = useCallback((event)=>{
        if (event.button === 0) {
            if (!isAboveMediumScreen || !isSelectable) return;
            isMouseDownRef.current = true;
            preSelectItem();
            window.addEventListener("mouseup", onMouseUp, {
                once: true
            });
        }
    }, [
        isAboveMediumScreen,
        isSelectable,
        onMouseUp,
        preSelectItem
    ]);
    return /*#__PURE__*/ _jsx("button", {
        className: "absolute inset-0 w-full",
        onClick: !isAboveMediumScreen || !isSelectable ? onClick : undefined,
        onMouseDown: onMouseDown
    });
});
ContentCollectionGalleryAssetButton.displayName = "ContentCollectionGalleryAssetButton";
